// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { OrderEditBaseUtils } from "../../../../Utils/Trading/OrderEditBaseUtils.js"
import { OrderEditUpdateData } from "../../../../Utils/Trading/OrderEditUpdateData.js"
import { OrderType } from "../../../../Utils/Trading/OrderType.js"
import { OrderExecutorUtils } from "../../../Trading/OrderExecutorUtils.js"
import { SLTPEdit } from "../SLTPEdit.js"
import { OrderEditBase } from "./OrderEditBase.js"
export let MarketOrderEdit = function (data)
{
    OrderEditBase.call(this, data)
    this.sltp = new SLTPEdit(data.dataCache, data.forceSLTPOffset)
    this.slBasePriceGetter = this.slBasePriceGetter.bind(this)
    this.tpBasePriceGetter = this.tpBasePriceGetter.bind(this)
}

MarketOrderEdit.prototype = Object.create(OrderEditBase.prototype)

MarketOrderEdit.prototype.getParameterNameArray = function ()
{
    return [
        OrderEditBaseUtils.POSITION_SIZING_PARAM,
        OrderEditBaseUtils.SLTP_PARAM
    ]
}

// TODO. Refactor. Same as OrderTypeBase.Id function.
MarketOrderEdit.prototype.getOrderTypeId = function ()
{
    return OrderType.Market
}

// TODO. Refactor. Use error/warning dicts for sltp.
// MarketOrderEdit.prototype.valid = function () {
//   return OrderEditBase.prototype.valid.call(this) &&
//     this.sltp.valid()
// }

MarketOrderEdit.prototype.update_sltp = function (updateData)
{
    return this.sltp.update(updateData, this.getTradingData())
}

MarketOrderEdit.prototype.toDynProperty_sltp = function ()
{
    return this.sltp.getDynProperty(this.getTradingData())
}

// #region Raw Values

MarketOrderEdit.prototype.toRawValue_sltp = function ()
{
    return this.sltp.getRawValue(this.getTradingData())
}

// #endregion Raw Values

MarketOrderEdit.prototype.validateParameters = function ()
{
    let updatedParamNameDict = {}

    if (this.sltp.validate(
        this.slBasePriceGetter,
        this.tpBasePriceGetter,
        this.getTradingData()))
    {
        updatedParamNameDict[OrderEditBaseUtils.SLTP_PARAM] = true
    }

    updatedParamNameDict[OrderEditBaseUtils.POSITION_SIZING_PARAM] = true

    return updatedParamNameDict
}

// #region SLTP Price Comparers

MarketOrderEdit.prototype.getBasePrice = function ()
{
    let result = 1

    let quote = this.quote
    if (quote)
        result = quote[this.buy() ? 'AskSpread_SP_Ins' : 'BidSpread_SP_Ins'](this.instrument.DataCache.GetSpreadPlan(this.account), this.instrument)

    return result
}

MarketOrderEdit.prototype.slBasePriceGetter = function ()
{
    let result = 1,
        isBuy = this.buy(),
        askOrBid = isBuy ? 'BidSpread_SP_Ins' : 'AskSpread_SP_Ins'  // согласно последнему комменту аналитика в https://tp.traderevolution.com/entity/101728

    let bySLTPtrigger = this.sltp.getSLTPTriggerStr(true, isBuy)    // picking trigger price #109798 docs(3.3.2) Trading logic)
    if (bySLTPtrigger)
        askOrBid = bySLTPtrigger + 'Spread_SP_Ins'

    let quote = this.quote
    if (quote)
        result = quote[askOrBid](this.instrument.DataCache.GetSpreadPlan(this.account), this.instrument)

    return result
}

MarketOrderEdit.prototype.tpBasePriceGetter = function ()
{
    let result = 1,
        isBuy = this.buy(),
        askOrBid = isBuy ? 'AskSpread_SP_Ins' : 'BidSpread_SP_Ins'  // согласно последнему комменту аналитика в https://tp.traderevolution.com/entity/101728

    let bySLTPtrigger = this.sltp.getSLTPTriggerStr(false, isBuy)    // picking trigger price #109798 docs(3.3.2) Trading logic)
    if (bySLTPtrigger)
        askOrBid = bySLTPtrigger + 'Spread_SP_Ins'

    let quote = this.quote
    if (quote)
        result = quote[askOrBid](this.instrument.DataCache.GetSpreadPlan(this.account), this.instrument)

    return result
}

// #endregion SLTP Price Comparers

MarketOrderEdit.prototype.getConfirmationText = function ()
{
    let quote = this.quote
    let buy = this.buy()

    let sp = this.instrument.DataCache.GetSpreadPlan(this.account)

    return OrderExecutorUtils.buildOrderEditConfirmationText(
        'panel.orders.Market', // TODO.
        this.tif,
        this.account,
        this.instrument,
        this.quantity,
        buy,
        quote ? ([buy ? quote.AskSpread_SP_Ins(sp, this.instrument) : quote.BidSpread_SP_Ins(sp, this.instrument)]) : [],
        this.sltp.getConfirmationText(this.getTradingData()),
        null,
        this.productType,
        OrderType.Market,
        null,
        this.getLeverageValue())
}

// TODO. UGLY. Refactor. details are at the top OrderEditBase.js
MarketOrderEdit.prototype.setSLTP = function (sltpHolder)
{
    let dp = this.sltp.createDynPropertyForRawSLTP(
        sltpHolder,
        this.getTradingData(),
        this.slBasePriceGetter,
        this.tpBasePriceGetter)

    this.updateParameters(new OrderEditUpdateData({ sltp: dp }))
}